import React, { useEffect, useMemo } from "react";
import { Grid, Paper, SpeedDial } from "@mui/material";
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import { DataGrid } from '@mui/x-data-grid';
import { useObrasState } from "./context/obras-context";
import { useObrasController } from "./context/obras-controller";
import { ObraDrawer } from "./components/obra-drawer";
import { getDataGridLocaleText, dataGridDefaultSx, dataGridDefaultProps } from "../../../config/datagrid-config";

export const Obras = () => {
    const { dataPaginatedListResponse, isLoadingData, dataSearchRequest } = useObrasState();
    const { loadData, onChangePagination, getColumnsGrid, openForm } = useObrasController();

    useEffect(() => {
        (async () => {
            await loadData(dataSearchRequest);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const paginationModel = useMemo(() => ({
        page: dataSearchRequest?.page ?? 0,
        pageSize: dataPaginatedListResponse?.pageSize ?? 10
    }), [dataSearchRequest?.page, dataPaginatedListResponse?.pageSize]);

    return (
        <React.Fragment>
            <ObraDrawer />

            <Grid item xs={12} md={12} lg={12}>
                <Paper sx={{ p: 2, minHeight: "500px", display: 'flex', flexDirection: 'column' }}>
                    <DataGrid
                        rows={dataPaginatedListResponse.items}
                        columns={getColumnsGrid()}
                        {...dataGridDefaultProps}
                        onPaginationModelChange={(e) => onChangePagination(e.page, e.pageSize)}
                        sx={dataGridDefaultSx}
                        localeText={getDataGridLocaleText(dataPaginatedListResponse.totalRecords, dataPaginatedListResponse.pageSize)}
                        paginationModel={paginationModel}
                        rowCount={dataPaginatedListResponse.totalRecords}
                        loading={isLoadingData}
                    />
                    <SpeedDial
                        ariaLabel="Nova Obra"
                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                        onClick={() => openForm()}
                        icon={<SpeedDialIcon />}
                    />
                </Paper>
            </Grid>
        </React.Fragment>
    );
};
